import { useState, useEffect } from "react";

// Site-wide toggle: show USD fees converted to INR. Persisted in localStorage; changes broadcast
// to every mounted FeeDisplay via a window event so the whole page switches at once.
const KEY = "showFeesInInr";
const read = () => localStorage.getItem(KEY) === "1";

export const getShowInr = read;

export function setShowInr(v) {
  localStorage.setItem(KEY, v ? "1" : "0");
  window.dispatchEvent(new Event("inr-toggle"));
}

// Seed the default from site_config only if the user hasn't set a preference yet.
export function initShowInrDefault(v) {
  if (localStorage.getItem(KEY) === null) {
    localStorage.setItem(KEY, v ? "1" : "0");
    window.dispatchEvent(new Event("inr-toggle"));
  }
}

export function useInrToggle() {
  const [v, setV] = useState(read());
  useEffect(() => {
    const h = () => setV(read());
    window.addEventListener("inr-toggle", h);
    return () => window.removeEventListener("inr-toggle", h);
  }, []);
  return [v, setShowInr];
}
